module.exports = __webpack_public_path__ + "static/media/portfolio1 (40).c204f6b3.jpeg";